import { useLocation } from 'react-router-dom';
import Navbar1 from './Navbar1';
import fabricImage from '../assets/FABRIC.png';

const Header = () => {
  const location = useLocation();

  // Function to return dynamic heading based on route
  const getHeadingText = () => {
    const path = location.pathname;

    switch (path) {
      case '/about':
        return 'About Us ';
      case '/career':
        return 'Careers ';
      case '/contact':
        return 'Contact Us';
      case '/fabrics':
        return 'Fabrics';
      default:
        return 'Welcome to \nKobinthan Garments';
    }
  };

  return (
    <div
      className="h-[40vh] min-h-[300px] mb-4 bg-customRed bg-cover bg-center flex flex-col w-full overflow-hidden relative"
      style={{
        backgroundImage: `url(${fabricImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
      id="SubHeader"
    >
      {/* Navbar positioned at the top */}
      <div className="relative z-10 w-full mb-10">
        <Navbar1 />
      </div>

      {/* Main content container */}
      <div className="relative z-0 container text-center mx-auto mt-20 md:px-20 lg:px-32 text-white">
        <h2 className="text-white text-2xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-[82px] whitespace-pre-line font-semibold pt-0 mb-8">
          {getHeadingText()}
        </h2>
      </div>
    </div>
  );
};

export default Header;
